

export const APP_URL = "https://app.devteamhq.org/"

export const APP_LAUCN = `${APP_URL}authorized`

export const APP_SIGNUP = `${APP_URL}login/1`
